export default {"id":"79c4df0a","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}